import { render } from "./Oncology.vue?vue&type=template&id=3e30505a&scoped=true"
import script from "./Oncology.vue?vue&type=script&lang=ts"
export * from "./Oncology.vue?vue&type=script&lang=ts"

import "./Oncology.vue?vue&type=style&index=0&id=3e30505a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3e30505a"

export default script